export default {
  title: 'Update {{name}} profile',
  form: {
    name: {
      label: 'Name',
      placeholder: 'Enter owner full name',
    },
    email: {
      label: 'Email',
      placeholder: 'Enter owner personal email',
      tooltip: 'Restaurant owner/manager personal email. Used as dashboard login',
    },
  },
  buttons: {
    save: 'Save',
  },
  toasts: {
    failed_to_save_changes: 'Failed to save changes',
    changes_got_saved: 'Changes got saved',
  },
};
